import type {FC} from 'react';
import {memo, useCallback, useEffect, useRef, useState} from 'react';

import styles from './styles.module.css';

interface Props {
  callBackHide: () => void;
  children: any;
  isAnimateShow: boolean;
}

const AnimateShow: FC<Props> = ({callBackHide, children, isAnimateShow}) => {
  const [isAnimate, setIsAnimate] = useState(false);

  const idT = useRef(0);

  const toggleVis = useCallback(
    (isShow: boolean) => {
      if (isShow) {
        clearTimeout(idT.current);

        idT.current = +setTimeout(() => {
          setIsAnimate(true);
        }, 300);
      } else {
        setIsAnimate(false);
        clearTimeout(idT.current);

        idT.current = +setTimeout(() => {
          callBackHide();
        }, 300);
      }
    },
    [callBackHide],
  );

  useEffect(() => {
    toggleVis(isAnimateShow);

    return () => {
      if (idT.current) {
        clearTimeout(idT.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAnimateShow]);

  return (
    <div
      className={`${styles.AnimateShow} ${isAnimate ? styles.visible : styles.hidden}`}
    >
      {children}
    </div>
  );
};

export default memo(AnimateShow);
